export const getMappedTokensByHash = (tokens) => Object.keys(tokens).reduce((result, token) => {
    if (!tokens[token].ibcs || tokens[token].ibcs?.length === 0) {
        return result;
    }
    tokens[token].ibcs?.forEach(ibc => {
        if (ibc.hash) {
            const hashKey = ibc.hash.toUpperCase();
            result[hashKey] = tokens[token];
        }
    });
    return result;
}, {});
//# sourceMappingURL=mapByHash.js.map